import { render, staticRenderFns } from "./accountFail.vue?vue&type=template&id=3f241d54"
import script from "./accountFail.vue?vue&type=script&lang=js"
export * from "./accountFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports